<template>
    <v-data-table
        :headers="headers"
        :items="educacion"
        hide-default-footer
        item-key="id"
        :search="search"
        no-data-text="No tiene Educación Externa para este periodo">
        <template v-slot:item.fechaActividad="{ item }">
            {{ dateFormat(item.fechaActividad) }}
        </template>
        <template v-slot:item.action="{ item }">
            <ModificarEducacionExtCompesacion 
                @reload="listarEducaActividadesCompesacion" 
                v-bind:educacionExt="item" 
                v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'"/>
            <AgregarEvidencia
                @reload="listarEducaActividadesCompesacion"
                :idEducacion="item.id"
                :origen="origen"
                :titulo="titulo"
                tooltipText="Agregar Evidencias"
                v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'">
            </AgregarEvidencia>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon 
                        color="#0B3F67" 
                        v-on="on"
                        @click="borrarEducacion(item.id)" 
                        v-if="rolUsuario != 'CEO' && rolUsuario != 'GERENTE' && rolUsuario != 'SUPERVISOR'">
                        mdi-trash-can-outline
                    </v-icon>
                </template>
                <span>Eliminar Evidenciass</span>
            </v-tooltip>
        </template>
        <template v-slot:item.evidencia="{ item }">
            <ListadosDocs 
                :idEducacion="item.id" 
                :idActividad="item.id"
                origen="EducacionExterna" 
                :titulo="titulo">
            </ListadosDocs>
        </template>

    </v-data-table>
</template>
<script>

import moment from "moment"
import ModificarEducacionExtCompesacion from "@/components/parametros/ActividadCompesacion/ModificarEducacionExternaComponent";
import AgregarEvidencia from "@/components/utils/AgregarEvidenciaComponent";
import ListadosDocs from "@/components/documentos/ListadoDocumentosComponent";
import axios from "@/axios.js";

export default {
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },  
    components: {
        ModificarEducacionExtCompesacion,
        AgregarEvidencia,
        ListadosDocs
    },
    props: [
        'headers',
        'educacion',
        'search'
    ],
    mounted() {
        setTimeout(function () {this.loadingModal(false)}.bind(this), 1000);
    },
    computed: {
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        instalacion() {
            return this.$store.getters.sucursal;
        },
        usuario(){
            return this.$store.getters.usuario;
        },
        rolUsuario(){
            return this.$store.getters.usuario.rol;
        }
    },
    data: () => ({
        titulo: "Documento(s) de Evidencia",
        origen: "EducacionExterna"
    }),
    methods: {
        dateFormat(fecha) {
            return fecha ? moment(fecha).format('DD/MM/YYYY') : '';
        },
        loadingModal(modal) {                        
            this.$store.dispatch('loadingPage', modal);
        },
        borrarEducacion(id) {
            this.$store.dispatch('confirma', {mensaje: 'Desea eliminar la educación ambiental exterrna?', show: true})
            .then((confirm) => {
                if (confirm) {
                    this.$store.dispatch('loadingPage', true);
                    this.cargando = true;
                    axios.delete("/actividadCompesacion/borrarEducacionExt/" + id, {params: {idUsuario: this.usuario.id}}).then(response => {
                        this.$store.dispatch('loadingPage', false);
                        this.$store.dispatch("noti", {
                            mensaje: "Educación Externa borrada",
                            color: "success"
                        });
                        this.cargando = false;
                        this.$emit('reload');
                        })
                        .catch(error => {
                        this.$store.dispatch('loadingPage', false);
                        this.$store.dispatch("noti", {
                            mensaje: "Educación Externa no se pudo borrar",
                            color: "success"
                        });
                        console.log(error);
                        this.cargando = false;
                        });
                }
            })
        },
        listarEducaActividadesCompesacion(){
            this.$emit('reload');
        },
    },
}
</script>